var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticClass:"video-player",attrs:{"preload":"auto","autoplay":"autopĺay","muted":"","loop":"","playsinline":"","id":"video-bg-main"},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/img/content2/arvore.mp4","type":"video/mp4"}})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h3',{staticClass:"py-2"},[_vm._v("Environmental Corporation")])])
}]

export { render, staticRenderFns }